<template>
    <div>
        <h1>{{$t("user.register.title")}}</h1>
        <UserForm :handle-submit="create" :values="item" :errors="violations" :isCreate="true"/>
    </div>
</template>

<script>
import UserForm from './Form.vue';
import {mapGetters} from 'vuex';


export default {
    components: {
        UserForm
    },
    data: function () {
        return {
            item: {
                maritalStatus: 0,
                language: 'fr_FR',
                acceptNotifications: false,
                tosAccept: false
            }
        }
    },
    computed: {
        ...mapGetters('user/create', [
            'created',
        ]),
        ...mapGetters('loading/loading', [
            'loading',
        ]),
        ...mapGetters('violation/list', [
            'violations'
        ])
    },
    methods: {
        create: function (item) {
            this.$store.dispatch('user/create/create', item);
        }
    },
    watch: {
        created: function (created) {
            if (created) {
                this.$router.push({name: 'UserValidationInfo'});
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Create.vue